import { PermissionLevel } from '../../constants/auth'

export const getHasPermission = (context: any, section: string) => {
   if (context?.access?.permissionLevel === PermissionLevel.OWNER) {
      return true
   }

   return context?.access?.sections?.includes?.(section)
}
